var installedModules = {};
var moduleToHandlerMapping = {
	90381: {
		getter: function() { return __webpack_require__.e(6540).then(function() { return function() { return __webpack_require__(96540); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.0.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["modern"],
		},
		shareKey: "react",
	},
	38815: {
		getter: function() { return Promise.all([__webpack_require__.e(1454), __webpack_require__.e(4179)]).then(function() { return function() { return __webpack_require__(24179); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.2.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router",
	},
	54663: {
		getter: function() { return __webpack_require__.e(2026).then(function() { return function() { return __webpack_require__(42026); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.4.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "reflux",
	},
	94919: {
		getter: function() { return __webpack_require__.e(961).then(function() { return function() { return __webpack_require__(40961); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.0.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["modern"],
		},
		shareKey: "react-dom",
	},
	56901: {
		getter: function() { return __webpack_require__.e(8989).then(function() { return function() { return __webpack_require__(28989); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.23.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-bootstrap",
	},
	61683: {
		getter: function() { return Promise.all([__webpack_require__.e(1376), __webpack_require__.e(7955)]).then(function() { return function() { return __webpack_require__(41376); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~2.4.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-intl",
	},
	18257: {
		getter: function() { return function() { return __webpack_require__(95093); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.30.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "moment",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"381": [
		90381
	],
	"1874": [
		56901,
		61683
	],
	"1927": [
		18257
	],
	"5235": [
		38815,
		54663,
		94919
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}